import React from "react";

export const TableData = ({ tableData }) => {
  if (!tableData) return null;

  const { caption, columns, rows, columnKeyMap } = tableData;

  return (
    <figure className="table">
      <table className="gdr">
        <caption style={{ captionSide: "top", textAlign: "center" }}>
          <p>{caption}</p>
        </caption>
        <thead>
          <tr>
            {columns.map((col, idx) => (
              <th
                key={idx}
                scope="col"
                style={{ textAlign: "center", verticalAlign: "bottom" }}
              >
                {col}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {rows.map((row, rowIdx) => (
            <tr key={rowIdx}>
              {columns.map((col, colIdx) => {
                // 만약 columnKeyMap가 제공되면 해당 매핑된 key를 사용
                const key = columnKeyMap ? columnKeyMap[col] : col;
                return (
                  <td key={colIdx} style={{ textAlign: "center" }}>
                    {row[key]}
                  </td>
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    </figure>
  );
};

export default TableData;
